import { useSettingsStore } from '@bv/stores/settings';
import { computed } from 'vue';

import ai_routes from '@/views/System/Ai/ai.route';
import campaigns_routes from '@/views/System/Campaigns/campaigns.route';
import contacts_routes from '@/views/System/Contacts/Contacts.route';
import conversations_routes from '@/views/System/Conversations/conversations.route';
import dashboard_routes from '@/views/System/Dashboard/dashboard.route';
import NotifcationsPanel from '@/views/System/Notifications/Components/NotifcationsPanel.vue';
import reports_routes from '@/views/System/Reports/reports.route';
import settings_routes from '@/views/System/Settings/settings.route';
import workflows_routes from '@/views/System/Workflow/workflow.route';

import UserStatus from '../components/layouts/UserStatus.vue';
import UserStatusList from '../components/layouts/UserStatusList.vue';

const isNewLayout = computed(() => useSettingsStore().layoutType === 'new');
const system_routes = {
  path: '/',
  name: 'main-view',
  redirect: { name: 'dashboard' },
  meta: {
    userStatus: UserStatus,
    userMenu: [UserStatusList],
    sidebarActions: computed(() => (isNewLayout.value ? undefined : [NotifcationsPanel])),
    headerActions: [
      {
        type: 'notifications' as const,
        component: NotifcationsPanel,
      },
    ],
  },
  children: [
    ...dashboard_routes,
    ...settings_routes,
    ...contacts_routes,
    ...conversations_routes,
    ...campaigns_routes,
    ...reports_routes,
    ...workflows_routes,
    ...ai_routes,
  ],
};

export default system_routes;
